import Link from 'next/link';
import op from './OurPartners.module.scss';
import gk from '/public/static/images/part2.webp';
import React from 'react';
import Image from 'next/image';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import { Flex, Typography } from 'antd';

const OurPartners = ({ titleClassName }: any) => {
    const LOCALIZATION = useLocalization();

    return (
        <Flex className={op.container}>
            <Flex className={op.titleBlock}>
                <Typography.Text className={titleClassName ? titleClassName : 'text-32-500'}>
                    {LOCALIZATION.pages.index.sevenCard.title}
                </Typography.Text>
            </Flex>
            <Flex className={op.container_body}>
                {Array(6)
                    .fill('')
                    .map((_, i) => (
                        <Link
                            key={i}
                            href={`/manufacturer/GKInstrument`}
                            className={`${op.item}`}
                        >
                            <Image
                                src={gk}
                                width={0}
                                height={0}
                                sizes={'100%'}
                                alt=""
                            />
                            <span
                                className={`text-16-500`}
                                style={{ color: '#FFFFFF' }}
                            >
                                {LOCALIZATION.pages.index.sevenCard.temp.companyTitle}
                            </span>
                        </Link>
                    ))}
            </Flex>
        </Flex>
    );
};

export default OurPartners;
